import { ReactNode } from 'react';
import { localize } from '@oneflowab/pomes';
import type { MessageTranslator } from '@oneflowab/pomes';

import Field from 'components/field';
import TextField from 'components/text-field';

type Props = {
  message: MessageTranslator;
  autoFocus?: boolean;
  label?: ReactNode | string;
};

const ContractNameFieldComponent = ({ message, autoFocus, label }: Props) => (
  <Field
    name="name"
    autoFocus={autoFocus}
    label={
      label ||
      String(
        message({
          id: 'New document name',
          comment: 'Label for contract name field.',
        }),
      )
    }
    component={TextField}
    placeholder={message({
      id: 'Enter name',
      comment: 'Placeholder for contract name field.',
    })}
    maxLength={130}
  />
);

export const ContractNameField = localize<Props>(ContractNameFieldComponent);
